import script from "./Rive.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rive.vue?vue&type=script&setup=true&lang=ts"

import "./Rive.vue?vue&type=style&index=0&id=6ed8a5d7&lang=scss"

const __exports__ = script;

export default __exports__